var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 17.35a1.63 1.63 0 1 0 0-3.26 1.63 1.63 0 0 0 0 3.26Z",
    fill: "#123862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.65 9.44h-9.3C3.25 9.44 2 10.69 2 14.79v1.86C2 20.75 3.25 22 7.35 22h9.3c4.1 0 5.35-1.25 5.35-5.35v-1.86c0-4.1-1.25-5.35-5.35-5.35ZM12 18.74c-1.67 0-3.02-1.36-3.02-3.02S10.33 12.7 12 12.7s3.02 1.36 3.02 3.02-1.35 3.02-3.02 3.02Z",
    fill: "#123862"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.12 9.45V8.28c0-2.93.83-4.88 4.88-4.88s4.88 1.95 4.88 4.88v1.17c.51.01.97.03 1.4.09V8.28C18.28 5.58 17.63 2 12 2S5.72 5.58 5.72 8.28v1.25c.42-.05.89-.08 1.4-.08Z",
    fill: "#123862"
  })));
};
export default SvgLock;